var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui segment" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", [
      _c("b", [_vm._v("Temporal extent")]),
      _vm._v(
        ": From " +
          _vm._s(_vm.temporalExtent.dateBeg) +
          " to " +
          _vm._s(_vm.temporalExtent.dateEnd) +
          " "
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui top attached label" }, [
      _c("i", { staticClass: "calendar check outline icon" }),
      _vm._v(" Temporal extent :")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }